module.exports = __webpack_public_path__ + "img/ic-add-comment.91e6bf6c.svg";